import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { HomeRocketSaas } from '../components/landing/HomeRocketSaas';

export function RocketSaasPage() {
  const { i18n } = useTranslation();

  useEffect(() => {
    document.title = 'RocketSaaS | Rocket Proxy';
  }, [i18n.language]);

  return (
    <div className="dx-saas-page animate-slide-up">
      <HomeRocketSaas variant="app" />
    </div>
  );
}
